import BASE_API from "../../shared/utility/base-api"

export const LEASE_ENDPOINT = {
  detail: `${BASE_API}/leases/get-lease`,
  list: `${BASE_API}/leases/get-leases`,
  getOwnersOfLease: `${BASE_API}/owners/get-owners`,
  getPropertiesForLease: `${BASE_API}/properties/get-properties`,
  getTenantsForLease: `${BASE_API}/tenants/get-tenants`,
  getUnitsForLease: `${BASE_API}/properties/get-units`,
  archive: `${BASE_API}/leases/archive-lease`,
  delete: `${BASE_API}/leases/delete-lease`,
  toggleStatus: `${BASE_API}/leases/change-lease-status`,
  restore: `${BASE_API}/leases/restore-lease`,
  archivedLeases: `${BASE_API}/leases/get-archived-leases`,
  archivedLease: `${BASE_API}/leases/get-archived-lease`,
  create: `${BASE_API}/leases/create-lease`,
  update: `${BASE_API}/leases/update-lease`,
  sendUtilityFeeReminder: `${BASE_API}/leases/send-utility-fee-reminder`,

  
  payForLeaseManually: `${BASE_API}/payments/pay-for-lease-manually`,
  payForTenantLeaseManually: `${BASE_API}/payments/pay-for-tenant-lease-manually`,

  detailRentIncrease: `${BASE_API}/rent-increases/get-rent-increase`,
  listRentIncrease: `${BASE_API}/rent-increases/get-rent-increases`,
  createRentIncrease: `${BASE_API}/rent-increases/create-rent-increase`,
  createBulkRentIncrease: `${BASE_API}/rent-increases/create-bulk-rent-increase`,
  updateRentIncrease: `${BASE_API}/rent-increases/update-rent-increase`,
  changeRentIncreaseStatus: `${BASE_API}/rent-increases/change-rent-increase-status`,
  deleteRentIncrease: `${BASE_API}/rent-increases/delete-rent-increase`,

  detailManagementFeeIncrease: `${BASE_API}/management-fee-increases/get-management-fee-increase`,
  listManagementFeeIncrease: `${BASE_API}/management-fee-increases/get-management-fee-increases`,
  createManagementFeeIncrease: `${BASE_API}/management-fee-increases/create-management-fee-increase`,
  createBulkManagementFeeIncrease: `${BASE_API}/management-fee-increases/create-bulk-management-fee-increase`,
  updateManagementFeeIncrease: `${BASE_API}/management-fee-increases/update-management-fee-increase`,
  changeManagementFeeIncreaseStatus: `${BASE_API}/management-fee-increases/change-management-fee-increase-status`,
  deleteManagementFeeIncrease: `${BASE_API}/management-fee-increases/delete-management-fee-increase`,
  
  export: `${BASE_API}/leases/export-leases`,

  getPaymentsForLease: `${BASE_API}/payments/get-payments`,
  removeFile: `${BASE_API}/leases/remove-image`,

  getUnitFloors: `${BASE_API}/properties/unit-floors`,
}
